import React, { useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import useMediaQuery from "@/hooks/useMediaQuery";

const SidePanel = ({ children, defaultExpanded = false }) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [collapsed, setCollapsed] = useState(
    isDesktop ? false : !defaultExpanded,
  );

  if (isDesktop) {
    return (
      <div
        className="h-full bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex flex-col"
        style={{
          width: collapsed ? 0 : 380,
          minWidth: collapsed ? 0 : 380,
          transition: "width 300ms ease-in-out, min-width 300ms ease-in-out",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto p-2" style={{ width: 380 }}>
          {children}
        </div>
        {/* Collapse/expand toggle — anchored to the right edge */}
        <button
          onClick={() => setCollapsed((c) => !c)}
          className="absolute top-2 -right-0 z-10 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-r-md p-1 shadow-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          style={{ transform: "translateX(100%)" }}
          aria-label={collapsed ? "Expand panel" : "Collapse panel"}
        >
          {collapsed ? (
            <ChevronRight className="w-4 h-4 text-gray-500" />
          ) : (
            <ChevronLeft className="w-4 h-4 text-gray-500" />
          )}
        </button>
      </div>
    );
  }

  // Mobile: bottom half of the screen
  return (
    <div
      className={`${collapsed ? "flex-none" : "flex-1"} bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex flex-col min-h-0`}
    >
      {/* Header bar */}
      <button
        onClick={() => setCollapsed((c) => !c)}
        className="w-full flex items-center justify-center gap-2 py-2 cursor-pointer select-none shrink-0"
      >
        <span className="text-sm font-medium" style={{ color: "inherit" }}>
          Route Info
        </span>
        {collapsed ? (
          <ChevronDown className="w-4 h-4" style={{ color: "inherit" }} />
        ) : (
          <ChevronUp className="w-4 h-4" style={{ color: "inherit" }} />
        )}
      </button>
      {/* Content */}
      {!collapsed && (
        <div className="flex-1 overflow-y-auto px-3 pb-4 min-h-0">
          {children}
        </div>
      )}
    </div>
  );
};

export default SidePanel;
